module.exports = __webpack_public_path__ + "static/media/ad.c9a08561.png";